import { render, staticRenderFns } from "./SGPIconComponent.vue?vue&type=template&id=567b5440"
import script from "./SGPIconComponent.vue?vue&type=script&lang=js"
export * from "./SGPIconComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports